import React from 'react'
import Navigation from '../navigation/Navigation';

const layout = (props) => {
    return(
        <Navigation />
    )
}

export default layout;